const _resources: Record<string, Record<string, string>> = {};

export const registerResources = (pluginKey: string, resources: Record<string, string>): void => {
  _resources[pluginKey] = resources;
};

export const unregisterResources = (pluginKey: string): void => {
  delete _resources[pluginKey];
};

export const getMergedResources = (): Record<string, string> => {
  return Object.values(_resources).reduce((acc, res) => ({ ...acc, ...res }), {});
};
